"use client";

import type { StrategyAllocationResponse } from "@/types/portfolio-builder.types";

interface Props {
  strategy: StrategyAllocationResponse;
}

function formatCurrency(n: number): string {
  return "$" + n.toLocaleString("en-US");
}

export function StrategyRecommendationCard({ strategy }: Props) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-gray-800 bg-gray-900/50 p-4">
      <div className="min-w-0 flex-1">
        <h4 className="truncate font-medium">{strategy.name}</h4>
        <p className="mt-0.5 text-xs text-gray-500">{strategy.slug}</p>
      </div>
      <div className="flex items-center gap-6 text-sm">
        <div className="text-center">
          <div className="text-gray-500 text-xs">Units</div>
          <div className="font-medium">{strategy.units}</div>
        </div>
        <div className="text-center">
          <div className="text-gray-500 text-xs">Allocation</div>
          <div className="font-medium text-blue-400">
            {formatCurrency(strategy.allocation)}
          </div>
        </div>
        <div className="text-center">
          <div className="text-gray-500 text-xs">Weight</div>
          <div className="font-medium">{(strategy.weight * 100).toFixed(1)}%</div>
        </div>
      </div>
    </div>
  );
}
